import { createFileRoute } from "@tanstack/react-router"
import LegalwarePowerUserGate from "@/components/coreLegalwarePowerUser/LegalwarePowerUserGate"

export const Route = createFileRoute("/legalware-power-user")({
  component: LegalwarePowerUserGate
})
